import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderTextField from "../inputs/renderTextField";
import Button from '@material-ui/core/Button';

const ChangePasswordForm =  (props) =>{
  const {submitPassword, handleSubmit, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(submitPassword)}>
      <div className={'form-group'}>
        <Field
          name="newPassword"
          label={'New password'}
          type="password"
          component={RenderTextField}
          required
          fullWidth
        />
      </div>
      <div className={'form-group'}>
        <Field
          name="retypedNewPassword"
          label={'Retyped new password'}
          type="password"
          component={RenderTextField}
          required
          fullWidth
        />
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Change'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary" className={'mr-3'}>
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  form: 'changePassword',
})(ChangePasswordForm);



// WEBPACK FOOTER //
// ./src/components/person/changePasswordForm.js